(() => {
  const options = {
    selectors: {
      contentStructureSearch: '.js-content-structure-search-form',
      searchTermInput: '.js-content-structure-search-input',
      suggestionsWrapper: '.autocomplete-suggestions'
    },
    constants: {
      DEFAULT_QUERY_DELAY: 500,
      MINIMUM_QUERY_LENGTH: 2
    }
  };

  // eslint-disable-next-line no-undef
  const contentStructureSearch = $(options.selectors.contentStructureSearch);
  const searchTermInput = contentStructureSearch.find(
    options.selectors.searchTermInput
  );
  const DEFAULT_QUERY_DELAY = options.constants.DEFAULT_QUERY_DELAY;
  const MINIMUM_QUERY_LENGTH = options.constants.MINIMUM_QUERY_LENGTH;

  contentStructureSearch.on('submit', buildURL);

  const suggestionsWrapper = document.querySelector(
    options.selectors.suggestionsWrapper
  );
  if (suggestionsWrapper) {
    suggestionsWrapper?.addEventListener('click', buildURL);
  }

  const initiateAutoComplete = () => {
    searchTermInput.devbridgeAutocomplete({
      appendTo: contentStructureSearch,
      serviceUrl: searchTermInput.data('autocomplete-url'),
      paramName: 'search_term',
      minChars: MINIMUM_QUERY_LENGTH,
      deferRequestBy:
        searchTermInput.data('autocomplete-delay') || DEFAULT_QUERY_DELAY,
      dataType: 'json',
      maxHeight: 'auto',
      width: 'flex'
    });
  };

  const buildURL = event => {
    event.preventDefault();
    const source =
      event.type === 'submit'
        ? 'content-structure-search-form'
        : 'content-structure-autocomplete';
    window.location.href = `${
      contentStructureSearch.action
    }?q=${searchTerm()}&src=${source}`;
  };

  const searchTerm = () => encodeURIComponent(searchTermInput.value);

  initiateAutoComplete();
})();
